export { default } from './info-banner'
